import React from 'react'
import { Fragment } from 'react'


export default function AyudaComponent() {
  return (
    <Fragment>
        <div className="banner position-relative" style={{ backgroundImage: "url(img/group-139.jpg)" }}>

            <div className="container py-2 py-md-3 py-xl-5">

              <div className="row">
                
                <div className="col-12">
                  <h2 className="text-center text-uppercase mb-5">¿NECESITAS AYUDA ADICIONAL?</h2>
                </div>
                
                <div className="col-12 col-md-4 offset-md-2 text-center alig-items-center">
                    <div className='item-ayuda-contacto mb-4 mb-lg-0'>
                      <h3 className="text-uppercase gotham-Bold primary-color mb-5 align-top">CHAT</h3>
                      <div className='content mb-5 d-flex justify-content-center align-items-center'>
                        <div className='wp'>
                          <p className="text-uppercase mb-0">De lunes a viernes</p>
                          <p className="text-uppercase mb-0">De 8:00 A.M a 5:00 P.M</p>
                          <p className="text-uppercase mb-0">Sabados</p>
                          <p className="text-uppercase mb-0">De 8:00 A.M a 12:00 P.M</p>
                        </div>
                      </div>
                      <a className="btn-g bb py-2 px-4 text-uppercase align-bottom">ir al chat</a>
                    </div>
                </div>

                <div className="col-12 col-md-4 text-center alig-items-center">
                    <div className='item-ayuda-contacto mb-4 mb-lg-0'>
                      <h3 className="text-center text-uppercase gotham-Bold primary-color mb-5 align-top">EMAIL</h3>
                      <div className='content mb-5 d-flex justify-content-center align-items-center'>
                        <div className='wp'>
                          <p className="text-uppercase mb-0">Evianos un mensaje</p>
                        </div>
                      </div>
                      <a className="btn-g bb py-2 px-4 text-uppercase align-bottom">ENVIAR MENSAJE</a>
                    </div>
                </div>
              </div>
            </div>
        </div> 
    </Fragment>
  )
}
